<template>
    <div class="page">
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box d-block d-sm-flex justify-content-sm-between">
                    <h4 class="page-title" id="page_title">My Deals</h4>
                    <div class="mt-3 mt-sm-0">
                        <div
                            class="btn-group btn-group-toggle"
                            data-toggle="buttons"
                            >
                            <label
                                v-for="deal_type_filter in deal_type_filters"
                                :class="{ 'bg-white text-dark': deal_type !== deal_type_filter.value }"
                                :key="deal_type_filter.value"
                                class="btn btn-primary"
                                >
                                <input
                                    @click="setDealType(deal_type_filter.value)"
                                    class="btn-group-toggle"
                                    name="options"
                                    type="radio"
                                    >
                                {{ deal_type_filter.label }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card card-body">
            <div class="mb-4">
                <listing @completed="onCompleted" />
            </div>
            <div class="mb-4">
                <listing
                    ref="completedOffers"
                    section="completed"
                    />
            </div>
            <div class="text-right mt-5">
                <button @click="goTo(Routes.vehicle)"
                        class="btn btn-secondary waves-effect waves-light"
                        type="button">
                    <i class="mdi mdi-car"/>
                    Back to Search
                </button>
                <button @click="goTo(Routes.dashboard)"
                        class="btn btn-primary waves-effect waves-light"
                        type="button">
                    <i class="mdi mdi-home"/>
                    Home
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import Routes from "@/constants/routes";
    import Listing from "@/components/main/pages/deal/Listing";

    export default {
        components: {
            Listing
        },
        data() {
            return {
                Routes,
                holds: {
                    data: [],
                    meta: {
                        fetched: false,
                        loading: false,
                        pagination: null
                    }
                },
                open_deals: {
                    data: [],
                    meta: {
                        fetched: false,
                        loading: false,
                        pagination: null
                    }
                },
                completed_deals: {
                    data: [],
                    meta: {
                        fetched: false,
                        loading: false,
                        pagination: null
                    }
                },
                deal_type: 0,
                deal_type_filters: [
                    {
                        value: 0,
                        label: 'Incoming'
                    },
                    {
                        value: 1,
                        label: 'Outgoing'
                    },
                ]
            }
        },
        created() {
            if (this.$route.query.deal_type) {
                this.deal_type = Number(this.$route.query.deal_type);
            }
        },
        methods: {
            goTo(name) {
                this.$router.push({
                    name
                })
            },
            onCompleted(offer) {
                this.$refs.completedOffers.refresh();
            },
            setDealType(deal_type) {
                this.deal_type = deal_type;
                this.$router.push({
                    name: Routes.deal,
                    query: {
                        deal_type: this.deal_type
                    }
                });
            },
        }
    }
</script>

<style scoped>

</style>
